const INDEX = 2;
export default INDEX;
